<script>
    // EU-Hinweis zur gesetzlichen Gewährleistung, Verordnung (EU) 2025/1960, Anhang I.
    // Auslöser + Modal mit der amtlichen Grafik der Kommission. decision: [1]
    import {t, teile} from "$utils/lang.js";

    // decision: [2]
    const NOTICE_URL = 'https://europa.eu/youreurope/garantien';
    // decision: [3]
    const NOTICE_IMAGE = '/out/m7-apex/img/eu/gewaehrleistungshinweis-de.svg';

    let dialog;
    let open = $state(false);

    $effect(() => {
        if (!dialog) return;
        if (open && !dialog.open) {
            dialog.showModal();
        } else if (!open && dialog.open) {
            dialog.close();
        }
    });

    function handleClose() {
        open = false;
    }

    function handleBackdropClick(e) {
        if (e.target === dialog) handleClose();
    }
</script>

<!-- decision: [5] -->
<p class="text-xsm text-black">
    <!-- reference: [m7_library Utils/i18n 3] -->
    {#each teile(t('Deine {link}')) as stueck}{#if stueck.platzhalter === 'link'}<button
        type="button"
        onclick={() => open = true}
        class="p-0 bg-transparent border-0 text-left text-elm underline cursor-pointer"
        data-checkout-action="eu-notice-open"
    >{t('Gewährleistungsrechte')}</button>{:else}{stueck.text}{/if}{/each}
</p>

<dialog
    bind:this={dialog}
    onclose={handleClose}
    onclick={handleBackdropClick}
    class="m-auto rounded-lg p-0 shadow-2xl backdrop:bg-black/50 backdrop:backdrop-blur-sm w-[740px] max-w-[95vw]"
    data-checkout-section="eu-notice-modal"
>
    <div class="bg-white p-5 flex flex-col gap-4">
        <div class="flex items-start justify-between gap-4">
            <h3 class="text-base font-bold text-cyprus">{t('Gesetzliche Gewährleistung')}</h3>
            <button
                type="button"
                onclick={handleClose}
                aria-label={t('Schließen')}
                class="shrink-0 px-2 py-1 bg-transparent border-0 text-lg leading-none cursor-pointer"
                data-checkout-action="eu-notice-close"
            >&times;</button>
        </div>

        <!-- decision: [4] -->
        <p class="text-xsm text-black">
            <a href={NOTICE_URL} target="_blank" rel="noopener noreferrer" class="text-elm underline"
               data-checkout-action="eu-notice-link">
                {t('Mehr dazu im EU-Portal „Ihr Europa“ (europa.eu/youreurope/garantien)')}
            </a>
        </p>

        <div class="overflow-x-auto">
            <a href={NOTICE_URL} target="_blank" rel="noopener noreferrer" data-checkout-action="eu-notice-image-link">
                <img
                    src={NOTICE_IMAGE}
                    alt={t('EU-Hinweis zur gesetzlichen Gewährleistung')}
                    class="block mx-auto h-auto w-full min-w-[600px] max-w-[700px]"
                    data-checkout-section="eu-notice-image"
                />
            </a>
        </div>
    </div>
</dialog>
